import { VFlow } from 'bold-ui'
import { FormSectionAccordion } from 'components/accordion/FormSectionAccordion'
import { RadioGroupField, simNaoEnumToBoolean, TextField } from 'components/form'
import { RecordStringSelectField } from 'components/form/final-form/RecordStringSelectField/RecordStringSelectField'
import { css } from 'emotion'
import { QuantidadeAlimentacaoDiariaEnum, TempoSituacaoDeRuaEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'

import {
  higienePessoalRecord,
  origemAlimentacaoRecord,
  quantidadeAlimentacaoDiariaRecord,
  SituacaoRuaFormModel,
  tempoSituacaoRuaRecord,
} from '../model-cidadaoFci'
import { AccordionItem } from './AccordionItem'

interface SituacaoRuaSection {
  meta: MetaPath<SituacaoRuaFormModel>
  values: SituacaoRuaFormModel
}

export const SituacaoRuaSection = ({ meta, values }: SituacaoRuaSection) => {
  return (
    <FormSectionAccordion
      name={meta.openedAccordion}
      title='Situação de rua'
      uuid='situacaoRua'
      textStyle={css`
        font-size: 1rem;
      `}
    >
      <VFlow vSpacing={0.1}>
        <AccordionItem
          title='Tempo de situação de rua'
          borderBottom
          childrenStyles={{
            marginRight: '4rem;',
          }}
        >
          <RadioGroupField
            name={meta.tempoSituacaoRua}
            clearable
            options={Object.values(TempoSituacaoDeRuaEnum).map((tempoSituacaoRua) => ({
              label: tempoSituacaoRuaRecord[tempoSituacaoRua],
              value: tempoSituacaoRua,
            }))}
          />
        </AccordionItem>
        <AccordionItem
          simNaoField
          name={meta.recebeAlgumBeneficio}
          title='Recebe algum benefício?'
          borderBottom
          clearable
        />
        <AccordionItem
          simNaoField
          name={meta.possuiReferenciaFamiliar}
          title='Possui referência familiar?'
          borderBottom
          clearable
        />
        <AccordionItem
          title='Quantas vezes se alimenta ao dia?'
          borderBottom
          childrenStyles={{
            display: 'flex;',
            justifyContent: 'flex-end',
            marginRight: '0.5rem',
          }}
        >
          <RadioGroupField
            name={meta.quantidadeAlimentacaoDiaria}
            clearable
            options={Object.values(QuantidadeAlimentacaoDiariaEnum).map((quantidadeAlimentacaoDiaria) => ({
              label: quantidadeAlimentacaoDiariaRecord[quantidadeAlimentacaoDiaria],
              value: quantidadeAlimentacaoDiaria,
            }))}
          />
        </AccordionItem>

        <AccordionItem title='Qual a origem da alimentação?' borderBottom>
          <RecordStringSelectField
            name={meta.origemAlimentacao}
            record={origemAlimentacaoRecord}
            multiple
            label='Indique qual(is)'
            title='Indique qual(is)'
            style={css`
              width: 416px;
              margin-right: 1rem;
            `}
          />
        </AccordionItem>
        <AccordionItem
          name={meta.possuiAcessoHigienePessoal}
          title='Tem acesso a higiene pessoal?'
          borderBottom
          simNaoField
          clearable
        >
          <RecordStringSelectField
            name={meta.higienePessoal}
            record={higienePessoalRecord}
            multiple
            required={simNaoEnumToBoolean[values?.possuiAcessoHigienePessoal] === true}
            disabled={simNaoEnumToBoolean[values?.possuiAcessoHigienePessoal] !== true}
            label='Indique qual(is)'
            title='Indique qual(is)'
            style={css`
              width: 416px;
              margin-right: 1rem;
            `}
          />
        </AccordionItem>
        <AccordionItem
          name={meta.stAcompanhadoOutraInstituicao}
          simNaoField
          clearable
          title='É acompanhado por outra instituição?'
          borderBottom
        >
          <TextField
            name={meta.instituicaoAcompanhamento}
            label='Indique qual(is)'
            disabled={simNaoEnumToBoolean[values?.stAcompanhadoOutraInstituicao] !== true}
          />
        </AccordionItem>
        <AccordionItem
          name={meta.visitaFamiliarComFrequencia}
          simNaoField
          title='Visita algum familiar com frequência?'
          clearable
        >
          <TextField
            name={meta.grauParentescoVisitaFamiliar}
            label='Qual é o grau de parentesco?'
            disabled={simNaoEnumToBoolean[values?.visitaFamiliarComFrequencia] !== true}
          />
        </AccordionItem>
      </VFlow>
    </FormSectionAccordion>
  )
}
